export const showAllSpeakers = 'Show All';
export const locationLondon = 'London';
export const locationSanFrancisco = 'San Francisco';
export const locationBoth = 'Both';
export const locations = [locationLondon, locationSanFrancisco, locationBoth];
